module.exports = __webpack_public_path__ + "static/media/criteria-2.2.3470ff76.jpg";